/* Public bridal registry page. Renders a registry from the wishlist worker's
 * public endpoint, lets guests add items to cart (tagged so the order webhook
 * marks them bought) and manually mark items purchased elsewhere. No login. */
(function () {
  'use strict';

  var root = document.querySelector('[data-jn-registry]');
  if (!root) return;

  var PROXY = (window.JN_WISHLIST && window.JN_WISHLIST.proxyBase) || root.getAttribute('data-proxy') || '/apps/wishlist';
  var ADD_LABEL = root.getAttribute('data-add-label') || 'Add to cart';
  var slug = (new URLSearchParams(window.location.search).get('r') || '').trim();

  var statusEl = root.querySelector('[data-registry-status]');
  var headerEl = root.querySelector('[data-registry-header]');
  var namesEl = root.querySelector('[data-registry-names]');
  var dateEl = root.querySelector('[data-registry-date]');
  var gridEl = root.querySelector('[data-registry-grid]');
  var emptyEl = root.querySelector('[data-registry-empty]');
  var notFoundEl = root.querySelector('[data-registry-notfound]');
  var findEl = root.querySelector('[data-registry-find]');
  var findForm = root.querySelector('[data-registry-find-form]');
  var findName = root.querySelector('[data-registry-find-name]');
  var findDate = root.querySelector('[data-registry-find-date]');
  var findMsg = root.querySelector('[data-registry-find-msg]');
  var findResults = root.querySelector('[data-registry-find-results]');
  var findSwitch = root.querySelector('[data-registry-find-switch]');

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function money(price) {
    if (!price || price.amount == null) return '';
    try { return new Intl.NumberFormat(undefined, { style: 'currency', currency: price.currency || 'USD' }).format(Number(price.amount)); }
    catch (e) { return price.amount + ' ' + (price.currency || ''); }
  }
  function fmtDate(iso) {
    if (!iso) return '';
    var m = /^(\d{4})-(\d{2})-(\d{2})/.exec(iso);
    if (!m) return '';
    var d = new Date(Number(m[1]), Number(m[2]) - 1, Number(m[3]));
    try { return d.toLocaleDateString(undefined, { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' }); }
    catch (e) { return iso; }
  }
  function variantId(gid) { var n = String(gid || '').split('/').pop(); return /^\d+$/.test(n) ? n : null; }
  function show(el) { if (el) el.hidden = false; }
  function hide(el) { if (el) el.hidden = true; }

  function showNotFound() { hide(statusEl); hide(headerEl); hide(gridEl); hide(emptyEl); hide(findEl); show(notFoundEl); }

  function showFind() {
    hide(statusEl); hide(headerEl); hide(gridEl); hide(emptyEl); hide(notFoundEl);
    show(findEl);
    if (findName) { try { findName.focus(); } catch (e) {} }
  }

  // Find a registry by the couple's name + exact event date (no link needed).
  function runFind(name, date) {
    if (findMsg) findMsg.textContent = 'Searching…';
    if (findResults) findResults.innerHTML = '';
    fetch(PROXY + '/registry/search?name=' + encodeURIComponent(name) + '&date=' + encodeURIComponent(date),
      { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : Promise.reject(new Error('http ' + r.status)); })
      .then(function (data) {
        var results = (data && data.results) || [];
        if (!results.length) {
          if (findMsg) findMsg.textContent = 'No registry found for that name and date. Please double-check both and try again.';
          return;
        }
        if (findMsg) findMsg.textContent = '';
        if (findResults) {
          findResults.innerHTML = results.map(function (r) {
            var names = esc(r.brideName || '') + (r.partnerName ? ' &amp; ' + esc(r.partnerName) : '');
            return '<button type="button" class="jn-reg-find-result" data-slug="' + esc(r.slug) + '">' +
              '<span>' + (names || 'Registry') + '</span>' +
              '<span class="jn-reg-find-result__date">' + esc(fmtDate(r.eventDate)) + '</span>' +
              '</button>';
          }).join('');
        }
      })
      .catch(function () { if (findMsg) findMsg.textContent = 'Sorry — search failed. Please try again.'; });
  }

  function cardHtml(p) {
    var vId = variantId(p.variant);
    var href = p.url || (p.handle ? '/products/' + p.handle : '#');
    var desired = Math.max(1, parseInt(p.desiredQty, 10) || 1);
    var bought = Math.max(0, parseInt(p.boughtQty, 10) || 0);
    var purchased = !!p.purchased || bought >= desired;

    var status = '';
    if (purchased) status = '<span class="jn-reg-card__badge">Purchased</span>';
    else if (bought > 0) status = '<span class="jn-reg-card__status--part">' + bought + ' of ' + desired + ' purchased</span>';
    else if (desired > 1) status = '<span class="jn-reg-card__status--part">Wants ' + desired + '</span>';

    var img = (p.image && p.image.url)
      ? '<img src="' + esc(p.image.url) + '" alt="' + esc((p.image && p.image.alt) || p.title || '') + '" loading="lazy">' : '';

    var actions = '';
    if (!purchased) {
      actions += vId
        ? '<button type="button" class="button jn-reg-card__add" data-reg-add data-vid="' + esc(vId) + '" data-pid="' + esc(p.id) + '">' + esc(ADD_LABEL) + '</button>'
        : '<a class="button button--secondary" href="' + esc(href) + '">Choose options</a>';
      actions += '<button type="button" class="jn-reg-card__mark" data-reg-mark data-pid="' + esc(p.id) + '">Mark as purchased</button>';
    }

    return '<article class="jn-reg-card' + (purchased ? ' is-purchased' : '') + '" data-reg-item="' + esc(p.id) + '">' +
      '<a class="jn-reg-card__media" href="' + esc(href) + '">' + img + '</a>' +
      '<div class="jn-reg-card__brand">' + esc(p.vendor || '') + '</div>' +
      '<a class="jn-reg-card__title" href="' + esc(href) + '">' + esc(p.title || '') + '</a>' +
      '<div class="jn-reg-card__price">' + esc(money(p.price)) + '</div>' +
      '<div class="jn-reg-card__status">' + status + '</div>' +
      '<div class="jn-reg-card__actions">' + actions + '</div>' +
      '</article>';
  }

  function render(data) {
    var reg = (data && data.registry) || {};
    var products = (data && data.products) || [];
    var names = esc(reg.brideName || '');
    if (reg.partnerName) names += ' &amp; ' + esc(reg.partnerName);
    if (namesEl) namesEl.innerHTML = names || 'Our Registry';
    var dt = fmtDate(reg.eventDate);
    if (dateEl && dt) { dateEl.textContent = dt; dateEl.hidden = false; }
    hide(statusEl); show(headerEl);

    if (!products.length) { show(emptyEl); return; }
    gridEl.innerHTML = products.map(cardHtml).join('');
    show(gridEl);
  }

  function reload() {
    fetch(PROXY + '/registry/view?r=' + encodeURIComponent(slug), { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : Promise.reject(new Error('http ' + r.status)); })
      .then(render).catch(showNotFound);
  }

  // Add to cart with registry attribution so the order webhook marks it bought.
  function addToCart(btn) {
    var vId = btn.getAttribute('data-vid');
    var pid = btn.getAttribute('data-pid');
    if (!vId) return;
    btn.disabled = true; var orig = btn.textContent; btn.textContent = 'Adding…';
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ items: [{ id: Number(vId), quantity: 1, properties: { _registry_slug: slug, _registry_product: pid } }] })
    }).then(function (r) { return r.ok ? r.json() : Promise.reject(); })
      .then(function () {
        var card = btn.closest('[data-reg-item]');
        btn.outerHTML = '<a class="button jn-reg-card__add" href="/cart">Added ✓ · View bag</a>';
        if (card) { var mark = card.querySelector('[data-reg-mark]'); if (mark) mark.hidden = true; }
      }).catch(function () { btn.disabled = false; btn.textContent = orig; alert('Sorry — could not add to bag. Please try again.'); });
  }

  function markPurchased(btn) {
    var pid = btn.getAttribute('data-pid');
    if (!pid) return;
    if (!window.confirm('Mark this item as purchased? It will show as bought on the registry.')) return;
    btn.disabled = true; btn.textContent = 'Saving…';
    fetch(PROXY + '/registry/bought', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ slug: slug, id: pid, qty: 1 })
    }).then(function (r) { return r.ok ? r.json() : Promise.reject(); })
      .then(function () { reload(); })
      .catch(function () { btn.disabled = false; btn.textContent = 'Mark as purchased'; alert('Sorry — could not update. Please try again.'); });
  }

  root.addEventListener('click', function (e) {
    if (!e.target.closest) return;
    var add = e.target.closest('[data-reg-add]');
    if (add) { e.preventDefault(); addToCart(add); return; }
    var mark = e.target.closest('[data-reg-mark]');
    if (mark) { e.preventDefault(); markPurchased(mark); return; }
    var result = e.target.closest('.jn-reg-find-result');
    if (result) { var s = result.getAttribute('data-slug'); if (s) window.location.search = '?r=' + encodeURIComponent(s); return; }
    var sw = e.target.closest('[data-registry-find-switch]');
    if (sw) { e.preventDefault(); showFind(); return; }
  });

  if (findForm) findForm.addEventListener('submit', function (e) {
    e.preventDefault();
    var name = (findName && findName.value || '').trim();
    var date = (findDate && findDate.value || '').trim();
    if (!name || !date) { if (findMsg) findMsg.textContent = 'Please enter both the couple’s name and the event date.'; return; }
    runFind(name, date);
  });

  if (!slug) { showFind(); return; }
  reload();
})();
